(function(){
	'use strict';
	angular
		.module('app.supplyChain')
		.controller('globalItemSearchResults', globalItemSearchResults);

	globalItemSearchResults.$inject = ['$rootScope', '$scope', '$timeout', '$location', '$translate', '$experiments', 'columnsService',
		'leanFilterService', 'tableService','tableRenderService', 'globalItemFilterFunctionsService'];

	function globalItemSearchResults($rootScope, $scope, $timeout, $location, $translate, $experiments, columnsService,
			leanFilterService, tableService, tableRenderService, globalItemFilterFunctionsService) {
		var vm = this;
		var reportSettingsName = 'item-search';
		var itemSearchExportEnabled = $experiments.isEnabled('item-search-export');
		var searchTerm = $location.search().search ? $location.search().search : '';
		try {
			searchTerm = decodeURIComponent(searchTerm);
		} catch (e) {
			searchTerm = $location.search().search;
		}
		var selectedFactories = sanitizeSelectedFactories($location.search().sites);
		$scope.filterService = leanFilterService;

		if ('' === searchTerm) {
			$rootScope.$emit('toast', {
				'message': $translate.instant('A search term must be provided'),
				'success': false
			});
		}

		// Extra query params to send to backend in data requests
		var extraParams = [{
			showExcel: itemSearchExportEnabled,
			excelReportName: 'Item Search'
		}, {
			'name': 'search',
			'value' : searchTerm
		}];
		// Extra drilldown query params to parse
		var rendererParams = {};

		var pinnedColumns = [];
		
		// Set navigation properties
		$timeout(function() {
			jQuery('#headingSupplyChainReports').addClass('selected');
			jQuery('#headingSupplyChainReports a').addClass('selected');
		}, 0);
		
		vm.showExcel = itemSearchExportEnabled;
		if (itemSearchExportEnabled) {
			vm.broadcastExcel = broadcastExcel;
		}
		vm.hideFilters = true;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Item Search';
		
		var columns = columnsService({
			itemCode: { show: 1, renderer: tableRenderService.itemSearchItemCode },
			itemDescription: { show: 1, display: 'Description', width: 120 },
			factoryName: { show: 1, renderer: factoryAliasOrNameRenderer },
			supplierName: 1,
			itemType: { show: 1, display: 'Type' },
			analysisAvgDailyDemandFloat: { display: 'Daily Requirements', width: 120, period: 'daily' },
			totalOnHandValue: 0,
			totalOnHandQuantityFloat: { display: 'On Hand Qty', show: 1 },
			buyerCode: 1,
			planner: 1
		});

		var factoriesList = globalItemFilterFunctionsService.getFactoryListString(4, selectedFactories);
		var extraText = $translate.instant('Search results for items containing \"%%searchTerm%%\" in %%factoriesList%%');
		extraText = extraText.replace('%%searchTerm%%', searchTerm);
		extraText = extraText.replace('%%factoriesList%%', factoriesList);

		var meta = {
			columns: columns,
			setColumnDefaults: true,
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			extraText: extraText,
			hideSearch: true,
			noPaging: false,
			pageSize: 50,
			pinnedColumns: pinnedColumns,
			rendererParams: rendererParams,
			reportSettingsName: reportSettingsName,
			reportUrl: selectedFactories.join(',') + '/ItemSearch'
		};

		if (itemSearchExportEnabled) {
			meta.useReportBuilderForExcel = true;
			meta.useExtraParamsForExcelWithReportBuilder = true;
			meta.excelRequest = true;
		}

		function getMeta() {
			return meta;
		}

		function getExcelColumns() {
			return columns;
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {
				columns: getExcelColumns(),
				doChooseColumns: true,
				exportFileName: 'Item Search'
			});
		}

		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, _.cloneDeep(columns)).then(function (response) {
				angular.forEach(response[0].data, function(row) {
					var factoryInfo = globalConfig.user.authFacts[row.factoryNdx];
					row.factoryName = factoryInfo.alias || factoryInfo.name;
				});
				return response;
			});
		}

		function sanitizeSelectedFactories(factoriesToCheck) {
			if(factoriesToCheck === 'LDNA_A_S'){
				return ['LDNA_A_S'];
			}

			var regexNonDigitsOrCommas = /[^\d^,]/;
			if (regexNonDigitsOrCommas.test(factoriesToCheck)) {
				return ['LDNA_A_S'];
			}

			factoriesToCheck = factoriesToCheck.split(',');
			var authorizedFactories = [];

			angular.forEach(factoriesToCheck, function(factory) {
				if (globalConfig.user.authFacts[factory]) {
					authorizedFactories.push(factory);
				}
			});
			return authorizedFactories.length ? authorizedFactories : 'LDNA_A_S';
		}

		function factoryAliasOrNameRenderer(row, col, rowIndex, params) {
			var factoryAlias = row.factoryAlias;
			var factoryName = row.factoryName;
			var formattedName = factoryAlias || factoryName;
			return '<div class="cell-div" title="' + formattedName + '">' + formattedName + '</div>';
		}

		init();

		function init() {
			$scope.filterService.clearFilters();
		}
	}
})();

